import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';

function Result(props) {

  function setCategory(medal) {
    switch (medal) {
      case 'gold':
        return 'I (prve)'
      case 'silver':
        return 'II (druge)'
      case 'bronze':
        return 'III (treće)'
      default:
        break;
    }
  }
  return (
    <CSSTransitionGroup
      className="container result"
      component="div"
      transitionName="fade"
      transitionEnterTimeout={800}
      transitionLeaveTimeout={500}
      transitionAppear
      transitionAppearTimeout={500}
    >
      <div>
        <strong>{props.points}</strong> od <strong>{props.total}</strong> poena!!
        {props.medal === 'none' &&
          <p>
            <p>Čitajte pitanja malo pažljivije...</p>
            <button type='button' className='next' onClick={() => window.location.reload(false)}>
              Pokušajte ponovo!
          </button>
          </p>
        }
        {props.medal !== 'none' &&
          <>
            <p>Čestitamo, postali ste real estate agent</p>
            <p><b>{ setCategory(props.medal)}</b> kategorije!</p>
            <p>
              <img className='medal' src={`https://dcjau2yrh9nxo.cloudfront.net/images/nekretnine/${props.medal}.png`} alt='' />
            </p>
            <p>
              Majo, srećan rođus, sve naj, naj, naj! 
            </p>
            <p>
              <img className='medal' src='https://dcjau2yrh9nxo.cloudfront.net/images/nekretnine/torta.png' alt='' />
            </p>
          </>
        }
      </div>
    </CSSTransitionGroup>
  );
}

Result.propTypes = {
  medal: PropTypes.string.isRequired,
  points: PropTypes.number.isRequired
};

export default Result;
